import { ctaDesc, ctaTitle } from "@/lib/seo";
// /en/translate/visa-docs — EN mirror
import { createFileRoute } from "@tanstack/react-router";
import { CertTypeHub } from "@/components/translate/CertTypeHub";
import { getCertType } from "@/data/translation-certtypes";
import { speakableSchema, serviceWithReviewsSchema, howToSchema } from "@/lib/aeo";
import { consolidateGraph } from "@/lib/schema-graph";
import { claimReviewSchema, softwareApplicationSchema, entitySameAsSchema, COMMON_CLAIM_REBUTTALS_EN } from "@/lib/trust-schema";

const SITE = "https://nyclanguageinstitute.com";
const cert = getCertType("visa-docs")!;

export const Route = createFileRoute("/en/translate/visa-docs")({
  head: () => {
    const url = `${SITE}/en/translate/visa-docs`;
    const title = "Visa Document Translation Pack Bangkok — US · UK · Schengen · AU | NYC";
    const desc = "Full visa document packs (bank statements, payslips, employment letters, house book. Start with a free review before you file anything.";
    return {
      meta: [
        { title: ctaTitle(title, "/en/translate/visa-docs", "en") }, { name: "description", content: ctaDesc(desc, "/en/translate/visa-docs", "en")},
        { name: "keywords", content: cert.keywords.join(", ") },
        { property: "og:title", content: ctaTitle(title, "/en/translate/visa-docs", "en")}, { property: "og:description", content: ctaDesc(desc, "/en/translate/visa-docs", "en")},
        { property: "og:url", content: url }, { property: "og:locale", content: "en_US" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: `${SITE}/translate/visa-docs` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/translate/visa-docs` },
      ],
      scripts: [
        speakableSchema(),
        howToSchema({
          name: "How NYC handles full visa document packs",
          description: cert.taglineEn,
          totalTime: "PT3D", estimatedCost: { currency: "THB", value: String(cert.priceFromThb) },
          steps: cert.stepsEn.map((s) => ({ name: s.name, text: s.text })),
        }),
        consolidateGraph([
          serviceWithReviewsSchema({ path: "/en/translate/visa-docs", serviceType: "Visa Document Translation Pack", name: title, description: desc, priceFromThb: cert.priceFromThb }),
          {
            type: "application/ld+json" as const,
            children: JSON.stringify({
              "@context": "https://schema.org", "@type": "FAQPage", "@id": `${url}#faq`, inLanguage: "en",
              mainEntity: cert.faqsEn.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
            }),
          },
        ]),
        entitySameAsSchema(),
        softwareApplicationSchema({ url: `${SITE}/api/public/mcp`, name: "NYC Language Institute — MCP Server", description: "AI agent endpoint exposing visa document translation tooling." }),
        claimReviewSchema(COMMON_CLAIM_REBUTTALS_EN(url)),
      ],
    };
  },
  component: () => <CertTypeHub cert={cert} locale="en" />,
});
